import filtrateHandleView from '@/components/table/filtrateHandleView'
export default {
  data() {
    return {
      chartColors: [
        '#6CA2FF',
        '#6AC9D7',
        '#72DCA2',
        '#48E78D',
        '#FECD51',
        '#DBB375',
        '#FF7474',
        '#F59561',
        '#A3AEBC',

        '#4C84FF',
        '#0DBEB4',
        '#00DEDE',
        '#FFAA00',
        '#C7C116',
        '#F7A57C',
        '#F661AC',
        '#8652EE'
      ]
    }
  },

  components: {
    filtrateHandleView
  },

  props: {},

  computed: {},

  watch: {},

  mounted() {},

  methods: {},

  deactivated: function() {}

}
